<template>
  <b-button :id="elementId"
            :class="{'text-600': current}"
            class="menu-option text-gray text-18"
            role="menuitem"
            @click="handleClick">
    <b-row class="menu-row"
           align-h="between"
           no-gutters>
      <b-col cols="auto">
        <span v-if="hasNotificationCount"
              :class="{'icon--count-mobile': isMobileOrSafari}"
              class="icon--count">
          {{ notificationCount }}
        </span>

        <inline-svg v-else-if="icon"
                    class="menu-svg"
                    :src="icon"
                    aria-hidden="true">
        </inline-svg>

        <span v-html="label"></span>
      </b-col>
      <b-col v-if="allowShowChevron"
             cols="auto">
        <div class="chevron"></div>
      </b-col>
    </b-row>
  </b-button>
</template>

<script>
// Components
import InlineSvg from './InlineSvg.vue'

// Libraries
import { mapState } from 'vuex'

// Utilities
import { BrowserType } from '../../../constants'

export default {
  name: 'sidebar-menu-option',

  components: {
    InlineSvg
  },

  props: {
    elementId: String,
    clickFunction: Function,
    label: String,
    icon: String,
    current: Boolean,
    notificationCount: {
      type: Number,
      default: 0
    },

    hasChildren: {
      type: Boolean,
      default: false
    }
  },

  mounted () {
    this.$root.$on('bv::collapse::state', this.toggleChevron)
  },

  beforeDestroy () {
    this.$root.$off('bv::collapse::state', this.toggleChevron)
  },

  data () {
    return {
      childCollapseOpen: false
    }
  },

  computed: {
    allowShowChevron () {
      // Don't show the chevron if the label is too long
      return this.childCollapseOpen && this.label && this.label.length < 25
    },

    hasNotificationCount () {
      return this.notificationCount > 0
    },

    isMobileOrSafari () {
      const isSafari = this.browserType === BrowserType.Safari
      return window.isMobileDevice || isSafari
    },

    ...mapState('display', ['browserType'])
  },

  methods: {
    handleClick () {
      if (this.hasChildren) {
        this.$emit('toggle')
      } else {
        this.clickFunction()
      }
    },

    toggleChevron (collapseId, collapseOpen) {
      if (collapseId === `${this.elementId}Collapse`) {
        this.childCollapseOpen = collapseOpen
      }
    }
  }
}
</script>

<style scoped>
.chevron {
  display: inline-block;
  width: 0.75rem;
  height: 0.75rem;
  margin-top: 0.5rem;
  margin-right: 1.5rem;
  margin-left: auto;
  border-width: 3px 3px 0 0;
}

.inl .chevron {
  border-color: #fff;
}

.inl .menu-option:focus .chevron {
  border-color: #000;
}

.inl .menu-option:hover .chevron {
  border-color: #000;
}

.tmx .menu-option:focus .chevron {
  border-color: #81cce4;
}

.tmx .menu-option:hover .chevron {
  border-color: #81cce4;
}

.icon--count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.94rem;
  margin-left: 0.94rem;
  color: white;
  background-color: #cc292f;
  border-radius: 1rem;
}

.icon--count-mobile {
  line-height: 1.25;
}

.menu-row {
  width: 100%;
}
</style>
